import { Helmet } from "react-helmet"
import { DashboardLayout } from "../../../components/layouts/DashboardLayout"
import { useState } from "react";
import { Header } from "../../../components/Header";
import { EmployeeCreate } from "./EmployeeCreate";
import { useHookEmployee } from "../../../hooks/useHookEmployee";
import { BtnDefault } from "../../../components/buttons/BtnDefault";
import { FiPhone, FiSearch, FiUser } from "react-icons/fi";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";

export const Employee = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const { data, meta, loading, error, refreshData, search, setSearch, sort, setSort, perPage, setPerPage, page, setPage } = useHookEmployee();

  const [openModalCreate, setOpenModalCreate] = useState(false);

  return (
    <>
      <Helmet>
        <title>Karyawan - DANELA NET</title>
      </Helmet>
      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* Header */}
        <Header toggleSidebar={() => setShowSidebar(true)}>
          <h2 className="text-base md:text-2xl font-bold text-gray-900">Management Karyawan</h2>
          <BtnDefault onClick={() => setOpenModalCreate(true)}>
            Tambah Data
          </BtnDefault>
        </Header>

        {/* Content */}
        <main className="p-4 lg:p-8">
          {/* Search and Filter Section */}
          <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-100 mb-6">
            <div className="flex flex-col gap-4">
              {/* Search Input */}
              <div className="w-full relative">
                <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg sm:text-xl" />
                <input
                  type="text"
                  placeholder="Cari Karyawan..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-9 sm:pl-10 pr-4 py-2.5 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
              </div>
            </div>

            {/* Results Count */}
            <div className="mt-4 text-xs sm:text-sm text-gray-600">
              Menampilkan {meta?.total ?? 0} dari {meta?.to ?? 0} Karyawan
            </div>
          </div>

          {/* Desktop Table View */}
          <div className="hidden lg:block bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-max max-w-screen-2xl">
                <thead className="bg-gradient-to-r from-indigo-50 to-purple-50">
                  <tr>
                    <th className="px-6 py-4 text-center">
                      Check
                    </th>
                    <th className="px-6 py-4 text-center">
                        No
                    </th>
                    <th className="px-6 py-4 text-left">
                      <button
                        // onClick={() => handleSortChange('name')}
                        className=" flex items-center font-semibold text-gray-700 hover:text-indigo-600 transition-colors"
                      >
                        Nama
                      </button>
                    </th>
                    <th className="px-6 py-4 text-left">
                      <button
                        // onClick={() => handleSortChange('phone_number')}
                        className="flex items-center font-semibold text-gray-700 hover:text-indigo-600 transition-colors"
                      >
                        Nomor Telepon
                      </button>
                    </th>
                    <th className="px-6 py-4 text-left font-semibold text-gray-700">Posisi/Jabatan</th>
                    <th className="px-6 py-4 text-left font-semibold text-gray-700">Tanggal Bergabung</th>
                    <th className="px-6 py-4 text-left font-semibold text-gray-700">Status</th>
                    <th className="px-6 py-4 text-center font-semibold text-gray-700">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data && data?.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                        <FiUser className="mx-auto text-4xl mb-3 text-gray-300" />
                        <p>Tidak ada karyawan yang ditemukan</p>
                      </td>
                    </tr>
                  ) : (
                    data?.map((item, index) => (
                      <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 text-center">
                            -
                        </td>
                        <td className="px-6 py-4 text-center">
                            {index + 1}
                        </td>
                        <td className="px-6 py-4 ">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold">
                              {item.name.charAt(0).toUpperCase()}
                            </div>
                            <span className="font-medium text-gray-900">{item.name}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-700 min-w-[200px]">
                          <div className="flex items-center gap-2">
                            <FiPhone className="text-gray-400" />
                            {item.phone_number}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-700 min-w-[200px]">
                          <div className="flex items-center gap-2">
                            {item?.position?.name}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-700 min-w-[200px]">
                          <div className="flex items-center gap-2">
                            {item.joining_date}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span
                            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${item.status === 'Aktif'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                              }`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-gray-700 text-end">
                          <div className="flex items-center gap-2">
                            <BtnDefault className="text-white bg-green-600 hover:bg-green-700">
                              <FaEye />
                            </BtnDefault>
                            <BtnDefault className="text-white bg-yellow-600 hover:bg-yellow-700">
                              <FaEdit />
                            </BtnDefault>
                            <BtnDefault className="text-white bg-red-600 hover:bg-red-700">
                              <FaTrash />
                            </BtnDefault>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Card List View */}
          {/* <div className="lg:hidden space-y-3">
            {filteredAndSorteditems.length === 0 ? (
              <div className="bg-white rounded-2xl shadow-lg p-12 text-center border border-gray-100">
                <FiUser className="mx-auto text-4xl mb-3 text-gray-300" />
                <p className="text-gray-500">Tidak ada item yang ditemukan</p>
              </div>
            ) : (
              filteredAndSorteditems.map((item) => (
                <div
                  key={item.id}
                  className="bg-white rounded-xl shadow-md p-4 border border-gray-100 hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0">
                      {item.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-gray-900 text-base mb-1">{item.name}</h3>
                      <div className="flex items-center gap-2 text-gray-600 mb-2">
                        <FiPhone className="text-gray-400 flex-shrink-0 text-sm" />
                        <span className="text-sm">{item.phone_number}</span>
                      </div>
                      <div>
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Aktif'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                            }`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div> */}
        </main>

      </DashboardLayout>

      {/* Create Nas */}
      <EmployeeCreate
        open={openModalCreate}
        setOpen={setOpenModalCreate}
        refreshData={refreshData}

      // setAlertMessage={setAlertMessage}
      // setAlertType={setAlertType}
      // setShowAlert={setOpenAlert}
      />

      {/* Update Nas */}
      {/* <EmployeeUpdate
        open={openModalUpdate}
        setOpen={setOpenModalUpdate}
        selectedData={selectedData}
        refreshData={refreshData}
        setAlertMessage={setAlertMessage}
        setAlertType={setAlertType}
        setShowAlert={setOpenAlert}
      /> */}
    </>
  )
}